import IWall from 'components/interfaces/IWall';
import IWallMetaData from 'components/interfaces/IWallMetaData';

const glassWallNameFilled = (wallMeta: IWallMetaData, wall: IWall): boolean =>
  wall.wallType === 'glass wall'
    ? wallMeta.name !== '' && wallMeta.name !== undefined
    : true;

export default glassWallNameFilled;
